import { render, staticRenderFns } from "./pop.vue?vue&type=template&id=631ce377&scoped=true"
import script from "./pop.vue?vue&type=script&lang=js"
export * from "./pop.vue?vue&type=script&lang=js"
import style0 from "./pop.vue?vue&type=style&index=0&id=631ce377&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631ce377",
  null
  
)

export default component.exports